import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from '@app/core';
import { RealTimeNotificationService } from '@shared/services/realTimeNotification/real-time-notification.service';
import { SignalrService } from '@app/core/signalr.service';
import { LoaderService } from '@app/core/loader.service';
import { RealTimeEvents } from '@app/core/signalr.events';
@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
})
export class ForbiddenComponent implements OnInit {
  permissions: any;
  constructor(
    public router: Router,
    private authService: AuthenticationService,
    private signalRService: SignalrService,
    private loaderService: LoaderService,
    public realTimeNotificationService: RealTimeNotificationService //private ngxpermissions: NgxPermissionsService
  ) {}
  ngOnInit() {
    this.loaderService.toggleMainLoader(false);
  }

  onLogout() {
    console.log(
      `${new Date().toDateString()} onLogout [forbidden.component.ts] line 685 => this.authService.logout() event called`
    );
    this.authService.logout();
    this.realTimeNotificationService.unsubscribeListeners();
    this.signalRService.invoke(RealTimeEvents.RemoveConnectionIds, this.authService.authData?.Email);
    if (this.signalRService.isConnected()) {
      this.signalRService.disconnect();
    }
    this.router.navigate(['/login']);
  }
}
